<template>
  <div>
    <div
      class="item coll2 comWrapper card mt-2 mb-2 p-3"
      v-for="(item, index) in viewData"
      :key="index"
    >
      <div class="comWrapper-wrapper van-hairline--bottom">
        <span style="background: #f44336"></span>
        {{ item[列[0].field] }}
      </div>
      <van-cell-group>
        <template v-for="(col, idx) in 列">
          <van-cell
            v-if="idx > 0"
            :key="'col_' + idx"
            :title="col.title"
            :value="item[col.field]"
          />
        </template>
        <van-button @click="viewDetail(item)" color="#1989fab7" block>查看详情</van-button>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import {getJudgmentDocCheckDetail} from '@/apis/company'
import checkMixin from './mixins/check-mixin'
export default {
  name: "judgmentDocCheck",
  mixins: [checkMixin],
  data(){
    return{
      列:[
        {title: "文书标题", field: "caseName"},
        {title: "案由", field: "caseReason"},
        {title: "案号", field: "caseNo"},
        {title: "案件金额（元）", field: "amount"},
        {title: "是否原告", field: "isProsecutor"},
        {title: "是否被告", field: "isDefendant"},
        {title: "裁判结果", field: "judgeResult"},
        {title: "裁判日期", field: "judgeDate"},
        {title: "发布日期", field: "publishDate"},
        {title: "当事人信息", field: "partyList"},
        {title: "案件类型", field: "caseType"}
      ],
      页码: 1,
      每页数据量: 10,
      viewData: [],
      ctv:{
        ms:'民事',
        xs:'刑事',
        xz:'行政',
        pc:'赔偿',
        zx:'执行',
        gx:'管辖案件',
        gsx:'国际司法协助案件',
        qsx:'区际司法协助案件',
        other:'其他'
      }
    }
  },
  methods:{
    setApi(cb){
      cb(getJudgmentDocCheckDetail, 'judgmentDocCheckDetail');
    },
    resetData(data, cb){
      data.relatedComList?.forEach((item,index)=>{
        item.sort = index + 1;
      })

      data.relatedLawList?.forEach((item,index)=>{
        item.sort = index + 1;
      })

      if(data?.defendantlist){
        res.data.defendantlist = data.defendantlist.join(',');
      }

      if(data?.prosecutorlist){
        data.prosecutorlist = data.prosecutorlist.join(',');
      }

      cb(data);
    },
    pagination(){
      this.viewData = this.data;
    }
  },
  created() {
    this.data.forEach(item=>{
      item.caseType = this.ctv[item.caseType];
    })
    console.log('this.data',this.data)
    this.pagination();
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
@import "./style.scss";
</style>